// src/App.js
import React, {useEffect} from "react";
import { useLocation } from 'react-router-dom';
import { ViewportProvider } from './context/ViewportContext';
import "./App.scss";
import "./assets/scss/_init.scss";
import "./assets/scss/_fonts.scss";
import "./assets/scss/menu.scss";
import "./assets/scss/style.scss"; 

// Redux
import { Provider } from 'react-redux';
import { store } from './store';

import FrontPage from "./axl2/FrontPage/FrontPage";

import PageModel from './axl2/PageModel/PageModel';

//import Home from "./components/AlphaHome/Home"
import Footer from "./axl2/Footer/Footer"
import About from './axl2/AlphaHome/About'
import CookieConsent from "./axl2/Helper/CookieConsent"

import {
  BrowserRouter,
  Route,
  Routes,
  Navigate, // Add this import
  Outlet,
} from "react-router-dom";

import { useViewport } from './context/ViewportContext';
// Hooks
import { useMenu } from "./hooks/useMenu";
import Header from "./axl2/Header/Header";


import '../node_modules/bootstrap/dist/css/bootstrap.min.css' 

/* export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
} */

  // Layout component with header
const Layout = () => {
  const { isMenuOpen, toggleMenu, closeMenu } = useMenu();
  
  return (
    <>
      <Header
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        closeMenu={closeMenu}
      />
      <div className="pt-16"> {/* Adjust based on your header height */}
        <Outlet />
      </div>
    </>
  );
};

function App() {

  
  return (
    <Provider store={store}>
      <BrowserRouter basename="/" >
       <ViewportProvider>
        {/* <ScrollToTop /> */}
        <div className="app-wrapper">
          
          <main className="maincontent">
            <Routes>
               <Route element={<Layout />}>
              <Route path="/" element={<FrontPage />} />

              <Route path="/product" element={<Navigate to="/product/model14" replace />} />
              <Route path="/product/model/:productId" element={<PageModel />} />
              {/* /import PageModel from './axl2/PageModel/PageModel'; */}

            <Route path="/home" element={<FrontPage />}  />

            <Route path="/about" element={<About />} />


              {/* Catch all route */}
              <Route path="/*" element={<FrontPage />} />
              </Route>
            </Routes>
          </main>
          
          <Footer />

          <CookieConsent />

        </div>
        </ViewportProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;